export default __webpack_public_path__ + "static/Date-Picker-Wheel-6b8e6ffa343255b444e717789bd53722.png";